<ng-container *ngrxLet="isMobile$; let isMobile">
  <div
    class="search-container"
    [class.is-mobile]="isMobile"
    (click)="onContainerClick(isMobile)"
  >
    <app-search-query-dropdown
      #desktopQuery
      class="query"
      [initialCategories]="categories$ | ngrxPush"
      (categorySelection)="onCategorySelectionChange($event)"
      (searchQueryChange)="onSearchTermChange($event)"
      (openChange)="onOpenChange($event, 'query', isMobile)"
      [class.active]="openDropdowns.includes('query')"
      (keyup.enter)="goToResults()"
    ></app-search-query-dropdown>

    <ng-container *ngIf="!isMobile">
      <app-search-date-dropdown
        class="date"
        (dateSelection)="onDateChange($event)"
        (openChange)="onOpenChange($event, 'date', isMobile)"
        [class.active]="openDropdowns.includes('date')"
      ></app-search-date-dropdown>

      <app-search-location-dropdown
        class="location"
        (locationSelection)="onLocationChange($event)"
        (openChange)="onOpenChange($event, 'location', isMobile)"
        [class.active]="openDropdowns.includes('location')"
      ></app-search-location-dropdown>

      <app-button
        class="search-container__button action"
        buttonStyle="action"
        (click)="goToResults()"
      >
        {{ 'explore' | t }}
      </app-button>
    </ng-container>
  </div>

  <app-search-mobile
    *ngIf="mobileVersionOpen"
    [show]="mobileVersionOpen"
    appClickOutside
    (clickOutside)="onClickOutside(isMobile)"
  >
    <app-search-query-dropdown
      query
      #mobileQuery
      class="query"
      [initialCategories]="categories$ | ngrxPush"
      [isMobile]="true"
      (categorySelection)="onCategorySelectionChange($event)"
      (searchQueryChange)="onSearchTermChange($event)"
      (openChange)="onOpenChange($event, 'query', isMobile)"
    ></app-search-query-dropdown>

    <app-search-date-dropdown
      date
      #mobileDate
      class="date"
      [isMobile]="true"
      (dateSelection)="onDateChange($event)"
      (openChange)="onOpenChange($event, 'date', isMobile)"
    ></app-search-date-dropdown>

    <app-search-location-dropdown
      [isMobile]="true"
      location
      #mobileLocation
      class="location"
      (locationSelection)="onLocationChange($event)"
      (openChange)="onOpenChange($event, 'location', isMobile)"
    ></app-search-location-dropdown>

    <div action class="mobile-actions">
      <app-button
        *ngIf="!isOpen && hasAnySelected()"
        class="search-container__button"
        buttonStyle="white"
        (click)="clearAll($event)"
      >
        Clear All
      </app-button>

      <app-button
        *ngIf="isDropdownClearable"
        class="search-container__button"
        buttonStyle="white"
        (click)="clear($event, isMobile)"
      >
        Clear
      </app-button>

      <app-button
        *ngIf="isOpen"
        class="search-container__button button-right action"
        buttonStyle="action"
        (click)="apply()"
      >
        Apply
      </app-button>

      <app-button
        *ngIf="!isOpen"
        class="search-container__button button-right action"
        buttonStyle="action"
        (click)="goToResults()"
      >
        {{ 'explore' | t }}
      </app-button>
    </div>
  </app-search-mobile>
</ng-container>
